import React, {useState, useMemo, useEffect} from "react";
import UserProfileContext from "./UserProfileContext";
import AuthAPI from "../../api/firebase/AuthAPI";

const UserProfileState = (props) => {
  const [state, setState] = useState(() => {
    try {
      const savedUser = localStorage.getItem("user");
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (e) {
      console.error("Error reading user from localStorage:", e);
      return null;
    }
  });
  const [loading, setLoading] = useState(() => {
    try {
      return !localStorage.getItem("user");
    } catch (e) {
      return false;
    }
  });
  const authAPI = useMemo(() => new AuthAPI(), []);

  const value = useMemo(
    () => ({
      state,
      setState,
      loading,
    }),
    [state, loading]
  );
  useEffect(() => {
    try {
      const savedUser = localStorage.getItem("user");
      const userProfile = savedUser ? JSON.parse(savedUser) : state;
      console.log("🔄 UserProfileState: Loading user from localStorage:", userProfile);
      
      if (userProfile) {
        const userId = userProfile.id || userProfile.uid;
        console.log("🆔 UserProfileState: Fetching user details for ID:", userId);
        
        // Fetch User Data using userID from firestore database
        authAPI.getUserDetailById(userId).then((res) => {
          console.log("📥 UserProfileState: Received user data from database:", res);
          console.log("📋 UserProfileState: User orders from database:", res?.orders?.length || 0, "orders");
          
          if (res?.orders) {
            res.orders.forEach((order, index) => {
              console.log(`📦 DB Order ${index + 1}: ID=${order.id}, Status=${order.status}`);
            });
          }
          
          if (res) {
            setState((prev) => ({...prev, ...res, id: userId}));
          }
          setLoading(false);
        }).catch((err) => {
          console.error("Error fetching user detail:", err);
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error("Error in UserProfileState init:", err);
      setLoading(false);
    }
  }, [authAPI]);

  useEffect(() => {
    try {
      if (state !== null && state !== undefined) {
        localStorage.setItem("user", JSON.stringify(state));
      } else {
        localStorage.removeItem("user");
      }
    } catch (e) {
      console.error("Error syncing user to localStorage:", e);
    }
  }, [state]);

  return (
    <UserProfileContext.Provider value={value}>
      {props.children}
    </UserProfileContext.Provider>
  );
};

export default UserProfileState;
